import { DocumentElement } from "../types/document";

/**
 * Deliberately empty while this page is UI-only, so enabling the release
 * flag outside local dev can never surface fake data. The real source is
 * asims-api GET /api/inspection (sections with ElementType 1 carry the
 * document elements, their assets and presigned download URLs), but that
 * endpoint rejects tech reviewers — surveyor/document-collector/admin auth
 * only, and 400 once an inspection reaches FULL_REPORT — so wiring it
 * needs an asims-api change first.
 */
export const getDocumentElements = async (
  _inspectionId: string
): Promise<DocumentElement[]> => {
  return Promise.resolve([]);
};
